import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PersonCircleIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="personCircle" ref={ref} {...props}>
      <path d="M12,13.65a4,4,0,1,1,4-4A4,4,0,0,1,12,13.65Zm0-6.57a2.54,2.54,0,1,0,2.54,2.54A2.54,2.54,0,0,0,12,7.08Zm0-5.4A10.32,10.32,0,1,0,22.32,12,10.33,10.33,0,0,0,12,1.68Zm0,19.14a8.72,8.72,0,0,1-5-1.6,2.84,2.84,0,0,1,2.8-2.47h4.5a2.84,2.84,0,0,1,2.8,2.47A8.72,8.72,0,0,1,12,20.82Zm6.32-2.68a4.32,4.32,0,0,0-4.07-2.89H9.75a4.32,4.32,0,0,0-4.07,2.89A8.74,8.74,0,0,1,3.18,12a8.82,8.82,0,0,1,17.64,0A8.74,8.74,0,0,1,18.32,18.14Z" />
    </Icon>
  ),
) as IconWithRender;

PersonCircleIcon.displayName = 'PersonCircleIcon';
PersonCircleIcon.renderIcon = (props) => <PersonCircleIcon {...props} />;
export default PersonCircleIcon;
